import { useEffect, useState } from "react";
import { PromptTemplateVar } from "../../../api";
import { defaultProcessingMessage, defaultTextProcess, EditVarsModalContentProps, UtilizeModalContentProps, VarElementFactory } from "./VarElementFactory";
import { ChoiceGroup, DefaultButton, Dropdown, IChoiceGroupOption, IconButton, PrimaryButton, Stack, Text, TextField } from "@fluentui/react";

const EditVarsModalContent_AddPulldown = (props: EditVarsModalContentProps) => {
    const {focusElement, vars, onVarsChanged, backToList} = props

    const [pulldownText, setPulldownText] = useState<string[]>([])
    const [name, setName] = useState(focusElement?.name ?? "")
    const [items, setItems] = useState(focusElement?.elements.join(",") ?? "")
    const [required, setRequired] = useState<string>(focusElement ? (focusElement?.is_required ? "required" : "not_required") : "")
    
    const options: IChoiceGroupOption[] = [
        { key: 'required', text: '必須' },
        { key: 'not_required', text: '任意' },
    ];
    const opeType = focusElement ? "修正" : "追加"

    useEffect(() => {
        const items_arr = items.split(/[,\n]/).map(item => item.trim()).filter(item => item.length > 0)
        setPulldownText(items_arr)
    }, [items])

    return (
        <form onSubmit={(e) => {
            if (!e.currentTarget.checkValidity()) {
              return
            }
            e.preventDefault()
            const newVar: PromptTemplateVar = {
                id: focusElement?.id ?? window.crypto.randomUUID(),
                name: name,
                description: "",
                is_required: required === "required",
                input_type: "PullDown",
                elements: pulldownText
            }
            // 修正
            if(focusElement){
                const newVars = vars.map(v => v.id === newVar.id ? newVar : v)
                onVarsChanged(newVars)
            }
            // 追加
            else {
                const newVars = [...vars]
                newVars.push(newVar)
                onVarsChanged(newVars)
            }
            backToList()
        }}>
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center" id="editvarsmodalcontent-header">
                <h2>
                  {`質問項目の${opeType} (プルダウン)`}
                </h2>
                <IconButton
                  iconProps={{iconName: 'Cancel'}}
                  onClick={backToList}
                />
            </Stack>
            <Stack id="editvarsmodalcontent-body" tokens={{childrenGap: "15px"}} style={{maxHeight: "70vh", minHeight: "70px", overflowY: "auto"}}>
                <TextField 
                    label="質問内容" 
                    style={{width: "100%"}} 
                    maxLength={1024}
                    required 
                    placeholder="例：会議のテーマはなんですか？"
                    value={name}
                    onChange={(e) => setName(e.currentTarget.value)}
                />
                <ChoiceGroup 
                    options={options} 
                    label="入力条件" 
                    required 
                    selectedKey={required}
                    onChange={(_, option) => setRequired(option?.key ?? "") }/>
                <Stack tokens={{childrenGap: "10px"}}>
                    <TextField 
                        label="プルダウン選択項目" 
                        placeholder="各項目をカンマまたは改行で区切って入力してください"
                        style={{width: "100%"}} 
                        maxLength={1024}
                        multiline rows={6}
                        value={items}
                        onChange={(e) => {
                            const text = e.currentTarget.value
                            setItems(text)
                        }}
                        required 
                    />
                    <Stack horizontal tokens={{childrenGap: "10px"}} style={{minHeight: "39px"}}>
                        {pulldownText.map((v, idx) => (<Text key={idx} style={{borderRadius: "5px", backgroundColor: "#eeeeee", padding: "10px"}}>{v}</Text>))}
                    </Stack>
                </Stack>
                <Stack horizontal tokens={{childrenGap: "26px"}} style={{marginTop: "20px", marginBottom: "20px"}}>
                    <PrimaryButton text={opeType} type="submit" style={{width: "120px"}} />
                    <DefaultButton text="キャンセル" style={{width: "120px"}} onClick={backToList} />
                </Stack>
            </Stack>
        </form>
    )
};

const VarElement_PullDown = (props: UtilizeModalContentProps) => {
    const [selectedValue, setSelectedValue] = useState(0)
    const { templateVar } = props
    return (<>
      <Dropdown 
        options={templateVar.elements.map((v, idx) => ({key: idx, text: v}))}
        label={templateVar.name}
        required={templateVar.is_required}
        selectedKey={selectedValue}
        onChange={(_, option) => {
          if (option) {
            setSelectedValue(option.key as number)
          }
        }}
      />
      <input type="hidden" name={templateVar.id} value={templateVar.elements.at(selectedValue)} />
    </>)
};

export const PullDownVarElementFactory: VarElementFactory = {
    inputType: "PullDown" as const,
    itemName: "プルダウン",
    isDroppableToRequest: true,
    iconName: "PageList",
    editVarsModalContent: EditVarsModalContent_AddPulldown,
    utilizeModalContent: VarElement_PullDown,
    processVar: defaultTextProcess,
    processingMessage: defaultProcessingMessage
}